module.exports = __webpack_public_path__ + "static/media/bg.810343ca.png";